import { DestroyRef, inject, Service, signal } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';

const GRACE_PERIOD_MS = 200;

@Service()
export class NavigationProgressService {
  router = inject(Router);
  destroyRef = inject(DestroyRef);

  visible = signal(false);

  graceTimer: Nullable<ReturnType<typeof setTimeout>> = null;

  constructor() {
    const subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.clearGraceTimer();
        this.graceTimer = setTimeout(() => {
          this.visible.set(true);
        }, GRACE_PERIOD_MS);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.clearGraceTimer();
        this.visible.set(false);
      }
    });

    this.destroyRef.onDestroy(() => {
      subscription.unsubscribe();
      this.clearGraceTimer();
    });
  }

  clearGraceTimer = () => {
    if (this.graceTimer !== null) {
      clearTimeout(this.graceTimer);
      this.graceTimer = null;
    }
  };
}
